var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          staticStyle: { "z-index": "2000" },
          attrs: {
            fullscreen: _vm.isFullscreen() && !_vm.alwaysModal,
            "max-width": _vm.getWidth
          },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c(
            "v-card",
            { class: [_vm.$style.modalWrapper, _vm.getStyle] },
            [
              _c(
                "v-content",
                { class: _vm.$style.modalContentContainer },
                [
                  _c(
                    "v-layout",
                    {
                      class: _vm.contentStyles,
                      attrs: {
                        "align-center": "",
                        "justify-center": "",
                        column: "",
                        "fill-height": ""
                      }
                    },
                    [
                      !_vm.alwaysModal
                        ? _c("div", { class: _vm.$style.modalHeader }, [
                            _c("h4", { class: _vm.$style.modalTitleMobile }, [
                              _vm._v(_vm._s(_vm.title))
                            ]),
                            _vm._v(" "),
                            _c("button", {
                              class: _vm.$style.modalClose,
                              on: {
                                click: function($event) {
                                  return _vm.close()
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { class: _vm.$style.logo }, [_c("Logo")], 1),
                      _vm._v(" "),
                      _vm.title
                        ? _c("v-flex", [
                            _c("h4", { class: _vm.$style.modalTitle }, [
                              _vm._v(_vm._s(_vm.title))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("default")
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/shared/components/CommonModal.vue?vue&type=template&id=a49462e2&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 